export const pencil =
  'M153.9,41.2l60.9,60.9l-142,142l-60.9-60.9L153.9,41.2z M1.8,254.2h40.6L1.8,213.6V254.2z M224.9,10.8c0,0-20.3-20.2-40.6,0C164,31,164,31,164,31l60.9,60.9c0,0,0,0,20.3-20.3c20.3-20.3,0-40.6,0-40.6L224.9,10.8z'
